/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var getYoutubeLink = require('./get.youtube.url');

/**
 * Video content class
 *
 * @param {Object} config - config to make video item
 * @constructor
 */
function Video ( config ) {
    config = config || {};

    /**
     * Name of video content
     *
     * @type {string}
     */
    this.title = config.title;

    /**
     *Type of content
     */
    this.contentType = config.contentType;

    /**
     * Url to play
     *
     * @type {string}
     */
    this.url = config.url;

    /**
     * Date of added
     */
    this.date = config.date;

    /**
     * Favorite state
     *
     * @type {boolean}
     */
    this.favorite = config.favorite || false;

    /**
     * Icon url
     *
     * @type {string}
     */
    this.icon = config.icon;

    /**
     * Source of page
     *
     * @type {string}
     */
    this.source = config.source;

    /**
     * Size of content
     */
    this.length = config.length;

}

Video.prototype = Object.create({});
Video.prototype.constructor = Video;

Video.prototype.TYPE_YOUTUBE = 'youtube';

/**
 * Toggle content favorite state
 *
 * @param {Function} callback - callback after toggling state
 */
Video.prototype.toggleFavorite = function ( callback ) {
    this.favorite = !this.favorite;

    if ( callback ) {
        callback(this.favorite);
    }
};

/**
 * Get video url
 *
 * @param {Function} callback - callback after getting video url
 */
Video.prototype.getUrl = function ( callback ) {
    if ( this.contentType === Video.prototype.TYPE_YOUTUBE ) {
        getYoutubeLink({url: this.url}, function ( error, data ) {
            console.log(data);
            callback(error, data.url);
        });
    } else {
        callback(false, this.url);
    }
};


module.exports = Video;
